import type {} from '@mui/x-date-pickers/themeAugmentation';
import { ControllerCalendarPickerColor } from '../../palette';

export const CalendarPickerComponent = {
  MuiCalendarPicker: {
    styleOverrides: {
      root: {
        backgroundColor: '#E7E6FE',
        border: `1px solid ${ControllerCalendarPickerColor.BorderNormal}`,
        '& .MuiCalendarPicker-viewTransitionContainer': {
          overflowY: 'hidden',
        },
        '& .MuiPickersDay-root': {
          backgroundColor: 'transparent',
        },
        '& .MuiTypography-caption': {
          color: 'inherit',
        },
      },
    },
  },
};
